import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import './App.css';
import Bio from './pages/Bio';
import Contact from './pages/Contact';
import Media from './pages/Media';
import Setup from './pages/Setup';
import Mixes from './pages/Mixes';
import Top5s from './pages/Top5s';
import homeArt from './media/home_art.jpg';
import logoMain from './media/logo_main.png';
import mixcloudLink from './media/mixcloud_link.png';
import mixcloudLinkHover from './media/mixcloud_link_focus.png';

function Navigation({ isHomePage, currentPath }: { isHomePage?: boolean; currentPath?: string }) {
  const showSetup = currentPath === '/setup';
  const showMixes = currentPath === '/mixes';
  const showTop5s = currentPath === '/top5s';

  return (
    <nav className="App-nav">
      <ul>
        {!isHomePage && <li><NavLink to="/">&larr;</NavLink></li>}
        <li><NavLink to="/bio">Bio</NavLink></li>
        <li><NavLink to="/contact">Contact</NavLink></li>
        <li><NavLink to="/media">Media</NavLink></li>
        {!isHomePage && <li><NavLink to="/top5s">Top 5s</NavLink></li>}
        {showMixes && <li><NavLink to="/mixes">Mixes</NavLink></li>}
        {showSetup && <li><NavLink to="/setup">Setup</NavLink></li>}
      </ul>
    </nav>
  );
}

function Home() {
  const location = useLocation();

  return (
    <div className="home-page" style={{ backgroundImage: `url(${homeArt})` }}>
      <div className="home-content">
        <div>
          <img src={logoMain} alt="Boogie Brown" className="home-logo" />
          <Navigation isHomePage={true} currentPath={location.pathname} />
        </div>
        <div className="mixcloud-promo">
          <p>Broadcasting Live Streams</p>
          <a href="https://www.mixcloud.com/live/dj_boogiebrown" target="_blank" rel="noopener noreferrer" className="mixcloud-link">
            <img src={mixcloudLink} alt="Mixcloud" onMouseOver={e => (e.currentTarget.src = mixcloudLinkHover)} onMouseOut={e => (e.currentTarget.src = mixcloudLink)} />
          </a>
        </div>
      </div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="App">
      {!isHomePage && <Navigation isHomePage={false} currentPath={location.pathname} />}
      <main className="App-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bio" element={<Bio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/top5s" element={<Top5s />} />
          <Route path="/media" element={<Media />} />
          <Route path="/mixes" element={<Mixes />} />
          <Route path="/setup" element={<Setup />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
